import { getCurrentTime, saveRecord } from '../reducer';

const STATE_DISPLAYS = {
  Cancelled: 'Passed'
};

const DATE_KEYS = {
  provided: 'ProvidedAt',
  accepted: 'AcceptedAt',
  modified: 'ModifiedAt',
  executed: 'ExecutedAt'
};

export function getAvailableStates(record) {
  const hasProduct = record.Product && record.Product.ProductId;
  const state = getCurrentState(record);

  switch (state) {
    case 'Received':
      return [
        { key: 'cancel', display: 'Pass', name: 'Cancelled', default: false },
        { key: 'provided', display: 'Provide', name: 'Provided', default: true, disabled: !hasProduct }
      ];
    case 'Provided':
      return [
        { key: 'cancel', display: 'Pass', name: 'Cancelled', default: false },
        { key: 'modified', display: 'Modify', name: 'Modified', default: false },
        { key: 'accepted', display: 'Accept', name: 'Accepted', default: true, disabled: !hasProduct }
      ];
    case 'Modified':
      return [
        { key: 'cancel', display: 'Pass', name: 'Cancelled', default: false },
        { key: 'modified', display: 'Modify', name: 'Modified', default: false },
        { key: 'accepted', display: 'Accept', name: 'Accepted', default: true, disabled: !hasProduct }
      ];
    case 'Accepted':
      return [
        { key: 'cancel', display: 'Pass', name: 'Cancelled', default: false },
        { key: 'executed', display: 'Execute', name: 'Executed', default: true, disabled: !hasProduct }
      ];
    case 'Executed':
      return [];
    default:
      return [
        { key: 'revert', display: 'Revert', name: 'Received', default: false }
      ];
  }
}

export function getCurrentState(rfq) {
  const state = rfq.Status;
  return mapStateDisplay(state);
}


function mapStateDisplay(state) {
  return STATE_DISPLAYS[state] || state;
}

export function changeState(state) {
  return (dispatch) => {
    const updateProps = {
      Status: state.name
    };

    const dateKey = DATE_KEYS[state.key];

    const firstStep = dateKey
      ? dispatch(getCurrentTime()).then((t) => { updateProps[dateKey] = t; })
      : Promise.resolve();

    return firstStep
      .then(() => dispatch(saveRecord(updateProps)));
  };
}



// WEBPACK FOOTER //
// ./src/recordDetail/states/rfqState.js